export default "__VITE_PUBLIC_ASSET__d35513fa__"